"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _formik = require("formik");
var _fn = require("@otpusk/apisearch-toolbox/dist/queries/fn");
var _static = require("@otpusk/json-api/dist/static");
var R = _interopRequireWildcard(require("ramda"));
var _enableCurrencies = require("../../../../../../constants/enableCurrencies");
var _Select = _interopRequireDefault(require("../../../../../ui/Select"));
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var getLabel = function getLabel(currency) {
  return currency.code === _static.CURRENCIES_MAP.kzt.code ? currency.symbol : currency.label;
};
var CURRENCIE_OPTIONS = R.map(function (currency) {
  return {
    content: R.join(' ', [R.toUpper(currency.code), getLabel(currency)]),
    value: currency.code
  };
}, (0, _enableCurrencies.getEnableCurrenciesList)());
var CurrencyControl = function CurrencyControl() {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.root
  }, /*#__PURE__*/_react.default.createElement(_formik.FastField, {
    name: _fn.QUERY_PARAMS.CURRENCY,
    render: function render(_ref) {
      var field = _ref.field,
        form = _ref.form;
      return /*#__PURE__*/_react.default.createElement(_Select.default, {
        items: CURRENCIE_OPTIONS,
        value: field.value,
        onChange: function onChange(code) {
          return form.setFieldValue(field.name, code);
        }
      });
    }
  }));
};
var _default = exports.default = (0, _react.memo)(CurrencyControl);